import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdClose } from 'react-icons/md';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { highlightedIdSuccess } from '../Redux/reducer/DataReducer';
import Constant from '../Components/Utils/Constant';

const SearchResult = ({ isOpen, onClose, searchTerm }) => {
    const modalRef = useRef(null);
    const [searchResults, setSearchResults] = useState({
        admin: [],
        affiliate: [],
        cupon: [],
        model: [],
        modelmanager: [],
        user: [],
    });
    const dispatch = useDispatch();
    const highlightedId = useSelector(state => state.highlightedId);

    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen && searchTerm) {
            axios
                .get(`${Constant.BASE_URL}/search/get`, { params: { q: searchTerm } })
                .then((response) => {
                    setSearchResults(response.data.results);
                })
                .catch((error) => {
                    console.error("Error fetching search results:", error);
                });
        }
    }, [isOpen, searchTerm]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    const handleview = (userId) => {
        dispatch(highlightedIdSuccess(userId));
    }

    const handleViewClick = (category, itemId) => {
        switch (category) {
            case 'Model':
                navigate('/');
                onClose();
                handleview(itemId);
                break;
            default:
                break;
        }
    };

    const renderCategory = (title, data) => (
        <div>
            <h3 className="px-4 py-3 text-left text-orange-500">
                {title}
                <hr className='w-[400px] h-[2px]' style={{ background: '#FF9900' }} />
            </h3>
            {data.length === 0 ? (
                <p className="px-4 py-3 text-gray-600">No results found.</p>
            ) : (
                <table className="min-w-full text-sm text-left text-gray-600">
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={item.id} className={index % 2 === 0 ? ' bg-gray-100' : 'bg-white-200'}>
                                <td className="px-4 py-2 text-gray-800">{item.id}</td>
                                <td className="px-4 py-2 text-gray-800">{item.modelname}</td>
                                <td className="px-4 py-2 text-gray-800">{item.phone}</td>
                                <td className="px-4 py-2 text-gray-800">{item.createdby}</td>
                                <td style={{ color: item.block ? 'red' : 'green' }}>
                                    {item.block ? 'Blocked' : 'Active'}
                                </td>
                                <td className="px-4 py-2 text-gray-800">{item.email}</td>
                                <td className="px-4 py-2 text-gray-800">
                                    <button
                                        className="text-blue-500 hover:underline"
                                        onClick={() => handleViewClick(title, item._id)}
                                    >
                                        View
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );

    return (
        <AnimatePresence>
            {isOpen && searchResults.model.length > 0 && (
                <motion.div
                    className="fixed inset-0 top-[70px] left-[100px] flex z-50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    style={{ backgroundColor: 'rgb(224 224 224 / 67%)' }}
                >
                    <motion.div
                        className="bg-white rounded-sm shadow-lg w-[60%] h-[500px] overflow-y-auto h-[490px]"
                        ref={modalRef}
                        initial={{ scale: 0.8 }}
                        animate={{ scale: 1 }}
                        exit={{ scale: 0.8 }}
                    >
                        <div className="flex justify-end mb-4">
                            <button onClick={onClose} className="text-red-600 text-2xl">
                                <MdClose />
                            </button>
                        </div>

                        <div className="overflow-x-auto">
                            {renderCategory('Model', searchResults.model)}
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default SearchResult;
